export const landingSliderTranslation = {
  en: {
    "S.No": "S.No",
    Title: "Title",
    Subtitle: "Subtitle",
    "Button Title": "Button Title",
    Image: "Image",
    Status: "Status",
    Actions: "Actions",
    Home: "Home",
    Landing: "Landing",
    "Landing Slider": "Landing Slider",
    "+ Add Slider": "+ Add Slider",
    "Search by title...": "Search by title...",
    "Edit Slider": "Edit Slider",
    "Add New Slider": "Add New Slider",
    "Update Slider": "Update Slider",
    "Add Slider": "Add Slider",
    "Title (EN)": "Title (EN)",
    "Title (AR)": "Title (AR)",
    "Subtitle (EN)": "Subtitle (EN)",
    "Subtitle (AR)": "Subtitle (AR)",
    "Button Title (EN)": "Button Title (EN)",
    "Button Title (AR)": "Button Title (AR)",
    "Button URL": "Button URL",
    "Slider No": "Slider No",
    "Drag & Drop or Click to Upload": "Drag & Drop or Click to Upload",
    "Supported formats: JPG, PNG": "Supported formats: JPG, PNG",
    Active: "Active",
    Inactive: "Inactive",
    "Are you sure you want to delete slider '{{sliderTitle}}'?":
      "Are you sure you want to delete slider '{{sliderTitle}}'?",
    "This action cannot be undone.": "This action cannot be undone.",
    Cancel: "Cancel",
    Delete: "Delete",
  },
  ar: {
    "S.No": "رقم",
    Title: "العنوان",
    Subtitle: "العنوان الفرعي",
    "Button Title": "عنوان الزر",
    Image: "صورة",
    Status: "الحالة",
    Actions: "الإجراءات",
    Home: "الرئيسية",
    Landing: "الصفحة الرئيسية",
    "Landing Slider": "شريط التمرير",
    "+ Add Slider": "+ إضافة شريط",
    "Search by title...": "البحث حسب العنوان...",
    "Edit Slider": "تعديل الشريط",
    "Add New Slider": "إضافة شريط جديد",
    "Update Slider": "تحديث الشريط",
    "Add Slider": "إضافة شريط",
    "Title (EN)": "العنوان (EN)",
    "Title (AR)": "العنوان (AR)",
    "Subtitle (EN)": "العنوان الفرعي (EN)",
    "Subtitle (AR)": "العنوان الفرعي (AR)",
    "Button Title (EN)": "عنوان الزر (EN)",
    "Button Title (AR)": "عنوان الزر (AR)",
    "Button URL": "رابط الزر",
    "Slider No": "رقم الشريط",
    "Drag & Drop or Click to Upload": "اسحب وأفلت أو انقر للتحميل",
    "Supported formats: JPG, PNG": "الصيغ المدعومة: JPG, PNG",
    Active: "نشط",
    Inactive: "غير نشط",
    "Are you sure you want to delete slider '{{sliderTitle}}'?":
      "هل أنت متأكد أنك تريد حذف الشريط '{{sliderTitle}}'؟",
    "This action cannot be undone.": "لا يمكن التراجع عن هذا الإجراء.",
    Cancel: "إلغاء",
    Delete: "حذف",
  },
};
